<template>
  <div class="def-map" @click="handlerClick"></div>
</template>

<script>
import { Loader } from '@googlemaps/js-api-loader';
import { MarkerClusterer } from '@googlemaps/markerclusterer';
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'DefMap',
  props: ['result'],
  data() {
    return {
      map: null,
      openPopUp: null,
      markers: [],
    };
  },
  watch: {
    // getActiveShop() {
    //     try {
    //         const prop = this.getActiveShop?.UF_STORE?.displayProperties;
    //         const lat = +prop?.LAT?.value;
    //         const lng = +prop?.LNG?.value;
    //
    //         if (lat && lng) {
    //             this.map.setCenter({ lat, lng });
    //             this.map.setZoom( 15 );
    //         }
    //     } catch (err) {
    //         console.error(err);
    //     }
    // }
  },
  computed: {
    ...mapState({
      googleMapsKeys: ({ results }) => results?.googleMapsKeys,
    }),
    ...mapGetters({
      isProd: 'isProd',
    }),
    getCenterMap() {
      try {
        // if (this.getActiveShop) {
        //     const prop = this.getActiveShop?.UF_STORE?.displayProperties;
        //     const lat = +prop?.LAT?.value;
        //     const lng = +prop?.LNG?.value;
        //
        //     return {
        //         center: { lat, lng },
        //         zoom: 15,
        //     }
        // } else {
        const initReducerValue = {
          lat: {
            min: 0,
            max: 0,
          },
          lng: {
            min: 0,
            max: 0,
          },
        };

        const center = this.$slots
          ?.default?.()?.[0]
          ?.children.reduce((accumulator, currentValue) => {
            const lat = currentValue?.props?.lat;
            const lng = currentValue?.props?.lng;
            // console.log(accumulator, currentValue);
            if (lat && lng) {
              if (accumulator.lat.min === 0 || accumulator.lat.min > lat) {
                accumulator.lat.min = lat;
              }
              if (accumulator.lat.max === 0 || accumulator.lat.max < lat) {
                accumulator.lat.max = lat;
              }

              if (accumulator.lng.min === 0 || accumulator.lng.min > lng) {
                accumulator.lng.min = lng;
              }
              if (accumulator.lng.max === 0 || accumulator.lng.max < lng) {
                accumulator.lng.max = lng;
              }
            }

            return accumulator;
          }, initReducerValue);

        const widthLat = center?.lat?.max - center?.lat?.min;
        const HeightLng = center?.lng?.max - center?.lng?.min;

        return {
          center: {
            lat: widthLat / 2 + +center?.lat?.min || 0,
            lng: HeightLng / 2 + +center?.lng?.min || 0,
          },
          zoom: 12 - (widthLat + HeightLng) || 7,
        };
        // }
      } catch (err) {
        console.error(err);
      }
    },
    // getActiveShop() {
    //     return Object.values(this.result)?.find(el => el.CHECKED === 'Y');
    // }
  },

  mounted() {
    const loader = new Loader({
      apiKey: this.isProd ? this.googleMapsKeys.prod : this.googleMapsKeys.develop,
      // apiKey: "AIzaSyBH5MD2A6cQXXRuLZQ0_HGEfekBZzFSc9A", // DEV
      // apiKey: "AIzaSyCWI_7qRCCrCECYGcenOL4Laphyh2B9TVc", // PROD
      version: 'weekly',
    });

    // init map
    this.initMap(loader);
  },
  methods: {
    createMarkers() {
      try {
        if (this.$slots?.default?.()) {
          this.markers = this.$slots
            ?.default?.()?.[0]
            ?.children?.map((shop) => this.createMarker(shop));

          new MarkerClusterer({ markers: this.markers, map: this.map });
        }
      } catch (err) {
        console.error(err);
      }
    },
    createMarker(shop) {
      try {
        const lat = shop?.props?.lat;
        const lng = shop?.props?.lng;
        const title = shop?.data?.attrs?.title;
        //
        if (lat && lng) {
          const domPopUp = App.helpers.vnodeToHtmlString(shop);
          // console.log(domPopUp);
          // console.log(domPopUp);
          // // add event to button
          // domPopUp.querySelector('button').addEventListener('click', () => {
          //     this.$emit('handlerSelectShop', { lat, lng });
          // });
          // console.log(domPopUp);

          // init popup
          const infoWindow = new google.maps.InfoWindow({
            content: domPopUp,
            maxWidth: 360,
          });

          // create marker
          const marker = new google.maps.Marker({
            position: {
              lat: +lat,
              lng: +lng,
            },
            map: this.map,
            animation: google.maps.Animation.DROP,
            optimized: true,
            title,
            icon: {
              url: '/local/templates/sova/images/map/marker.svg',
            },
          });

          // eventListener open popup
          marker.addListener('click', this.handlerOpenPopup.bind(this, infoWindow, marker));
          return marker;
        }
      } catch (err) {
        console.error(err);
      }
    },
    handlerOpenPopup(infoWindow, marker) {
      try {
        // close previous popup
        this.openPopUp?.close();

        // add animation for popup
        marker.setAnimation(google.maps.Animation.BOUNCE);

        // remove animation from popup
        setTimeout(() => {
          marker.setAnimation(null);

          // open new popup
          infoWindow.open({
            anchor: marker,
            map: this.map,
            shouldFocus: false,
          });

          this.openPopUp = infoWindow;
        }, 750);
      } catch (err) {
        console.error(err);
      }
    },
    async initMap(loader) {
      try {
        await loader.load();
        // init map
        this.map = new google.maps.Map(this.$el, this.getCenterMap);
        // create markers
        this.createMarkers();
      } catch (err) {
        console.error(err);
      }
    },
    handlerClick({ target }) {
      if (target.closest('.def-map-popup__button')) {
        const parent = target.closest('.def-map-popup');

        const lat = parent.getAttribute('lat');
        const lng = parent.getAttribute('lng');

        this.$emit('handlerSelectShop', { lat, lng });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.def-map {
}
:deep {
  .def-map-popup {
    &__title {
      font-size: 16px;
      font-weight: 600;
      line-height: 125%;
      text-transform: uppercase;
      margin-bottom: 12px;
      @include point-lg {
        font-size: 18px;
      }
    }
    &__text {
      display: flex;
      align-items: center;
      font-size: 16px;
      font-weight: 500;
      line-height: 125%;
      color: #5f5f67;
      gap: 8px;
      margin-bottom: 8px;
      svg {
        width: 20px;
        height: 20px;
        fill: currentColor;
      }
    }
    &__button {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 44px;
      background-color: var(--background-black);
      margin-top: 24px;
      width: 100%;
      color: #fff;
      transition: 0.2s linear background-color;
      &:hover {
        background-color: #38383a;
      }
      &:disabled {
        /* меняем внешний вид курсора */
        cursor: progress;
        /* делаем кнопку полупрозрачной */
        opacity: 0.25;
      }
    }
    &__markerButton {
      height: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      width: 100%;
      border: 1px solid var(--color-main);
      transition: 0.2s linear background-color;
      margin-top: 16px;
      font-size: 14px;
      font-weight: 600;
      line-height: 20px;
      text-transform: uppercase;
      &:hover {
        background-color: rgba(61, 61, 81, 0.05);
      }
    }
  }
  .gm-ui-hover-effect {
    top: -3px !important;
    right: -3px !important;
  }
  .gm-style-iw-chr {
    display: none;
  }
  .gm-style-iw-d {
    padding-top: 12px;
  }
}
</style>
